import React from 'react';
import { connect } from 'react-redux';
import i18next from 'i18next';
import ScrollArea from 'react-scrollbar';
import ReactTable from 'react-table';
import Select from 'react-select';
import { PageTitle } from '../PageTitle';
import {
  DevicesService,
  GroupingsService,
  TagsService,
  TimeFormattingService
} from '../../services';
import { SelectInput } from '../SelectInput';
import { ScrollModule } from '../ScrollModule';
import { TextInput } from '../TextInput';
import { CustomMultiValueContainer } from '../ReactSelectCustomMultiValueContainer';
import { CustomMultiValueLabel } from '../ReactSelectCustomMultiValueLabel';
import { Link } from 'react-router-dom';

@connect(state => ({
  me: state.user.me,
  currentGrouping: state.currentGrouping.currentGrouping
}))

class DevicesBulkEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      filteredData: [],
      searchValue: '',
      selectedGrouping: null,
      selectedTag: null,
      selectedArea: null,
      isFetching: false,
      groupingForTable: null,
      groupingFilterOptions: null,
      tagFilterOptions: null,
      areaFilterOptions: null,
      updatedRows: []
    };
    this.updateSelectedGrouping = this.updateSelectedGrouping.bind(this);
    this.updateSelectedTag = this.updateSelectedTag.bind(this);
    this.updateSelectedArea = this.updateSelectedArea.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
    this.doSearch = this.doSearch.bind(this);
    this.processChanges = this.processChanges.bind(this);
  }

  componentDidMount() {
    if (this.state.groupingFilterOptions == null) {
      if (this.props.me.adhocRoleAssignment) {
        setTimeout(() => {
          const groupingFilterOptions = [{
            label: null,
            options: this.props.me.availableGroupings.map(grouping => ({
              fqn: grouping.fullyQualifiedName,
              label: grouping.name,
              value: `${grouping.id}`
            }))
          }];
          this.setState({
            groupingFilterOptions,
            selectedGrouping: this.state.selectedGrouping
          });
        }, 100);
      } else {
        GroupingsService.getAllWithAccess(this.props.currentGrouping.id).then((response) => {
          const groupingFilterOptions = response.groupings;
          this.setState({
            groupingFilterOptions,
            selectedGrouping: this.state.selectedGrouping
          });
        }).catch((error) => {
          console.error(error);
          this.state.localErrorHandler(error.message);
        });
      }
    }
    if (this.state.tagFilterOptions == null) {
      TagsService.listAll().then((response) => {
        this.setState({
          tagFilterOptions: this.mapTagOptions(response.tags.filter(tag => tag.tagType && tag.tagType.token !== 'area')),
          areaFilterOptions: this.mapTagOptions(response.tags.filter(tag => tag.tagType && tag.tagType.token === 'area'))
        });
      }).catch((error) => {
        console.error(error);
        this.setState({ errorMessage: i18next.t('messages.could-not-load-tags-view') });
      });
    }
  }

  mapTagOptions(tags) {
    return tags.sort((a, b) => {
      if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
      } else if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
      }
      return 0;
    }).map(tag => ({ label: tag.name, value: tag.id, tagType: tag.tagType }));
  }

  doSearch(val) {
    this.setState({ searchValue: val.target.value }, () => {
      this.updateTableFilters();
    });
  }

  updateSelectedTag({ value }) {
    this.setState({ selectedTag: value === '' ? null : value }, () => {
      this.updateTableFilters();
    });
  }

  updateSelectedArea({ value }) {
    this.setState({ selectedArea: value === '' ? null : value }, () => {
      this.updateTableFilters();
    });
  }

  refreshTable() {
    this.setState({
      groupingForTable: this.state.selectedGrouping,
      data: [],
      filteredData: [],
      isFetching: true,
      searchValue: '',
      selectedTag: null,
      selectedArea: null
    }, () => {
      DevicesService.listAllForGrouping(this.state.selectedGrouping, false, false, true).then((response) => {
        const pageCount = Math.ceil(response.devices.length / (this.devicesTable ? this.devicesTable.state.pageSize : 25));
        const forcePage = 0;
        this.setState({
          data: response.devices,
          filteredData: response.devices.sort((a, b) => a.displayName.localeCompare(b.displayName)),
          pageCount,
          forcePage,
          isFetching: false
        });
      }).catch((error) => {
        console.error(error);
        this.setState({ hasError: true });
        this.setState({ data: [], filteredData: [], isFetching: false, pageCount: 0, recordsTotal: 0, recordsFiltered: 0 });
        this.state.localErrorHandler(error.message);
      });
    });
  }

  updateTableFilters() {
    this.setState({
      filteredData: this.state.data.filter(device =>
        this.state.searchValue === '' || device.displayName.toLowerCase().includes(this.state.searchValue.toLowerCase())
      )
        .filter(device =>
          this.state.selectedTag === null || device.tags.some(tag => tag.id === this.state.selectedTag)
        )
        .filter(device =>
          this.state.selectedArea === null || device.tags.some(tag => tag.id === this.state.selectedArea)
        )
    });
  }

  updateSelectedGrouping({ value }) {
    this.setState({
      selectedGrouping: value
    });
  }

  updateRowName(updatedValue, row) {
    const localFilteredData = this.state.filteredData.map((device) => {
      const temp = Object.assign({}, device);
      if (temp.id === row._original.id) {
        temp.displayName = updatedValue;
        temp.touched = true;
      }
      return temp;
    });
    this.setState({
      filteredData: localFilteredData
    });
  }

  updateRowTags(updatedValueObject, selectProps, row, area) {
    const localFilteredData = this.state.filteredData.map((device) => {
      const temp = Object.assign({}, device);
      if (temp.id === row.id) {
        const normalizedChosenTagList = updatedValueObject.map(chosenDevice => ({
          ...chosenDevice,
          id: chosenDevice.value,
          name: chosenDevice.label
        }));
        const otherTags = row.tags.filter(tag => tag.tagType && (area ? tag.tagType.token !== 'area' : tag.tagType.token === 'area'));
        temp.tags = [...otherTags, ...normalizedChosenTagList];
        temp.touched = true;
      }
      return temp;
    });
    this.setState({
      filteredData: localFilteredData
    });
  }

  renderDisplayName(value, props) {
    return (
      <TextInput
        input={{ defaultValue: props.row.displayName,
          onBlur: (e) => {
            this.updateRowName(e.target.value, props.row);
          }
        }}
        type="text"
        meta={{}}
        className="input-container"
      />
    );
  }

  renderAreas(data) {
    const areas = this.mapTagOptions(data.original.tags ? data.original.tags.filter(tag => tag.tagType && tag.tagType.token === 'area') : null);
    return (
      <div className="style-as-tag">
        <Select
          {...this.props}
          components={{ MultiValueContainer: CustomMultiValueContainer, MultiValueLabel: CustomMultiValueLabel }}
          className="react-select-container"
          classNamePrefix="react-select"
          options={this.state.areaFilterOptions}
          name="selected-filter-by"
          isClearable
          isMulti
          value={areas}
          onChange={(e, val) => {
            this.updateRowTags(e, val, data.original, true);
          }}
          searchable
          placeholder={i18next.t('form-placeholders.area-filter')}
          menuPortalTarget={document.body}
          multiContainerClassname="multi-value-tag"
        />
      </div>
    );
  }

  renderTags(data) {
    const tags = this.mapTagOptions(data.original.tags ? data.original.tags.filter(tag => tag.tagType && tag.tagType.token !== 'area') : null);
    return (
      <div className="style-as-tag">
        <Select
          components={{ MultiValueContainer: CustomMultiValueContainer, MultiValueLabel: CustomMultiValueLabel }}
          className="react-select-container"
          classNamePrefix="react-select"
          options={this.state.tagFilterOptions}
          name="selected-filter-by"
          isClearable
          isMulti
          value={tags}
          onChange={(e, val) => {
            this.updateRowTags(e, val, data.original, false);
          }}
          searchable
          placeholder={i18next.t('form-placeholders.tag-filter')}
          menuPortalTarget={document.body}
          multiContainerClassname="multi-value-tag"
        />
      </div>
    );
  }

  renderNormalTime(data) {
    const timezone = data.original.deviceGrouping &&
    data.original.deviceGrouping.timezone ? data.original.deviceGrouping.timezone : null;
    const date = TimeFormattingService.renderDate(data.value, timezone);
    const time = TimeFormattingService.renderTime(data.value, timezone);
    return (<span>{ date }<br />{ time }</span>);
  }

  processChanges() {
    const changedDevices = this.state.filteredData.filter(device => device.touched).map(device => ({
      id: device.id,
      displayName: device.displayName,
      tags: device.tags.map(tag => ({ id: tag.id }))
    }));
    DevicesService.bulkUpdateConfiguration(changedDevices).then((response) => {
      this.refreshTable();
    }).catch((error) => {
      console.error(error);
      this.setState({ hasError: true });
      this.setState({ data: [], filteredData: [], isFetching: false, pageCount: 0, recordsTotal: 0, recordsFiltered: 0 });
      this.state.localErrorHandler(error.message);
    });
  }

  render() {
    const {
      filteredData,
      groupingFilterOptions,
      tagFilterOptions,
      areaFilterOptions,
      selectedGrouping,
      searchValue,
      selectedArea,
      selectedTag,
      groupingForTable,
      isFetching
    } = this.state;
    if (groupingFilterOptions && tagFilterOptions && areaFilterOptions) {
      return (
        <div className="device-bulk-edit">
          <div className="row">
            <PageTitle
              title={i18next.t('pages.device-bulk-edit.header')}
              backLinkWithParams={{
                link: {
                  pathname: '/config/devices',
                  search: this.props.backLinkSearch
                }
              }}
            />
          </div>
          <div className="op-content-box">
            <div className="row">
              <div className="col-sm-12">
                <div className="table-topper-filter-container">
                  <div className="inner">
                    <div className="form-group">
                      <SelectInput
                        name="deviceGrouping"
                        filterGroupHeading
                        input={{
                          value: groupingFilterOptions.map(optionCat =>
                          optionCat.options.find(option => option.value === selectedGrouping)),
                          onChange: this.updateSelectedGrouping
                        }}
                        options={groupingFilterOptions}
                        isSearchable
                        meta={{}}
                        placeholder={i18next.t('form-placeholders.group-filter')}
                      />
                      <button className="btn btn-sm btn-default" onClick={this.refreshTable}>
                        Update Results
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12">
                <div className="card-block">
                  {groupingForTable && (
                    <div className="device-list">
                      <ScrollModule />
                      <ScrollArea
                        speed={0.8}
                        className="scroll-container"
                        contentClassName="scrollable-content"
                        horizontal
                      >
                        <div className="react-table-custom">
                          <ReactTable
                            getTheadFilterThProps={(state, rowInfo, column) => ({
                              style: {
                                overflow: 'visible'
                              }
                            })}
                            className="-striped -highlight"
                            ref={(el) => { this.devicesTable = el; }}
                            data={filteredData}
                            loading={isFetching} // Display the loading overlay when we need it
                            totalElements={filteredData.length}
                            showPaginationTop
                            style={{ paginationTop: { width: '200px' } }}
                            columns={[
                              {
                                Header: i18next.t('table-headers.device-name'),
                                id: 'displayName',
                                accessor: 'displayName',
                                Cell: ({ value, ...props }) => this.renderDisplayName(value, props),
                                sortable: false,
                                minResizeWidth: 50,
                                filterable: true,
                                Filter: <div className="filter">
                                  <i className="table-search-icon" />
                                  <TextInput
                                    className="table-search-box"
                                    input={{ value: searchValue,
                                      onChange: this.doSearch }}
                                    type="text"
                                    meta={{}}
                                  />
                                </div>
                              },
                              {
                                Header: i18next.t('table-headers.area'),
                                accessor: 'deviceArea',
                                Cell: row => (this.renderAreas(row)),
                                sortable: false,
                                minResizeWidth: 50,
                                filterable: true,
                                Filter: () => (
                                  <div className="filter select-filter">
                                    <SelectInput
                                      name="area"
                                      input={{
                                        value: areaFilterOptions.find(option => option.value === selectedArea),
                                        onChange: this.updateSelectedArea
                                      }}
                                      options={[
                                          { label: i18next.t('show-all'), value: '' }
                                      ].concat(areaFilterOptions)}
                                      isSearchable
                                      meta={{}}
                                      placeholder={i18next.t('show-all')}
                                    />
                                  </div>
                                  )
                              },
                              {
                                Header: i18next.t('table-headers.tags'),
                                id: 'deviceTag',
                                accessor: 'tags',
                                Cell: row => (this.renderTags(row)),
                                sortable: false,
                                minResizeWidth: 50,
                                filterable: true,
                                Filter: () => (
                                  <div className="filter select-filter">
                                    <SelectInput
                                      name="tags"
                                      input={{
                                        value: tagFilterOptions.find(option => option.value === selectedTag),
                                        onChange: this.updateSelectedTag
                                      }}
                                      options={[
                                          { label: i18next.t('show-all'), value: '' }
                                      ].concat(tagFilterOptions)}
                                      isSearchable
                                      meta={{}}
                                      placeholder={i18next.t('show-all')}
                                    />
                                  </div>
                                  )
                              }
                            ]}
                          />
                        </div>

                      </ScrollArea>
                      <ul className="list-inline clearfix bulk-edit-buttons">
                        <li>
                          <button className="btn btn-primary" type="button" onClick={this.processChanges}>{ i18next.t('form-labels.save') }</button>
                        </li>
                        <li>
                          <Link to="/config/devices">
                            <button className="btn btn-default">{ i18next.t('form-labels.cancel') }</button>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="loader">{i18next.t('loading')}</div>
    );
  }
}

export default DevicesBulkEdit;
